import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import FetchSelect from '../../../core/form/FetchSelect';
import get from 'lodash/get';
import Select from '../../../core/form/Select';
import { startCase } from 'lodash';
import Button from '../../../core/form/Button';

const CharacterListFilter = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <FetchSelect
          label="Academic Plan"
          value={get(props.values, 'academicPlan', '')}
          onChange={(id, data) => {
            props.onChange('academicPlan', id);
            props.onChange('academicPlanKey', data.key);
          }}
          disabled={props.submitting}
          errorText={get(props.errors, 'academicPlan', '')}
          url="academic-plans"
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={3}>
        <TextInput
          disabled={props.submitting}
          label="Name"
          value={get(props.values, 'name', '')}
          onChange={(value) => props.onChange('name', value)}
          errorText={get(props.errors, 'name', null)}
        />
      </Column>
      <Column size={2}>
        <Select
          options={[
            'american',
            'australian',
            'british',
            'canadian',
            'indian',
            'japanese',
            'new-zealand',
            'russian',
            'scottish',
            'spanish',
            'south-african',
          ].map((value) => ({
            value,
            label: startCase(value),
          }))}
          required
          disabled={props.submitting}
          label="Accent"
          value={get(props.values, 'accent', '')}
          onChange={(value) => props.onChange('accent', value)}
        />
      </Column>
      <Column size={1}>
        <div style={{ marginTop: 44 }}>
          <Button
            icon="search"
            disabled={props.isSubmitting}
            loading={props.isSubmitting}
            buttonType="submit"
            label="Search"
          />
        </div>
      </Column>
    </Row>
  </form>
);

CharacterListFilter.propTypes = {
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

export default CharacterListFilter;
